import { useContext, useDeferredValue, useState } from "react";

import { useGenomeViewerStore } from "../../../store/store.ts";
import { TrackConfigurationContext } from "../TrackConfigurationContext.ts";

export const useGenomePanel = () => {
  const trackGroups = useGenomeViewerStore((state) => state.trackGroups);
  const { trackConfiguration } = useContext(TrackConfigurationContext);
  const alignedTrackGroupStarts = useGenomeViewerStore((state) => state.alignedTrackGroupStarts);
  const [filterTerm, setFilterTerm] = useState<string>();
  const debouncedFilterText = useDeferredValue(filterTerm);

  const sortedGroups = new Map(
    [...trackConfiguration.keys()]
      .filter((id) => trackGroups.has(id))
      .map((id) => {
        const trackGroup = trackGroups.get(id)!;
        return [id, trackGroup];
      }),
  );

  const filteredTrackGroups = new Map(
    [...sortedGroups.entries()].filter(([_, group]) =>
      debouncedFilterText != undefined
        ? group.contigName.toLowerCase().includes(debouncedFilterText.toLowerCase()) ||
          group.organismName.toLowerCase().includes(debouncedFilterText.toLowerCase())
        : true,
    ),
  );

  return {
    alignedTrackGroupIds: alignedTrackGroupStarts ? Array.from(alignedTrackGroupStarts.keys()) : undefined,
    filteredTrackGroups,
    setFilterTerm,
  };
};
